import BookingWidget from "./BookingWidget";

export default BookingWidget;
